import { render, staticRenderFns } from "./AppSnack.vue?vue&type=template&id=27ca89f6&scoped=true&"
import script from "./AppSnack.vue?vue&type=script&lang=ts&"
export * from "./AppSnack.vue?vue&type=script&lang=ts&"
import style0 from "./AppSnack.vue?vue&type=style&index=0&id=27ca89f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca89f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
